﻿'use strict';

angular.module('ntmApp').factory('ListGridRowActions', ['$q', 'ListGridStatus', 'ListGridHelper', 'ListGridConstants', 'ProfileActions', 'ConfirmationService',
    function ($q, ListGridStatus, ListGridHelper, ListGridConstants, ProfileActions, ConfirmationService) {

    function ListGridRowActions(type, callback) {

        var self = this;

        var showRoomHistory = false;

        self.selectedRow = null;
        self.editedRow = null;

        self.getRowActions = function (row) {
            return ListGridStatus.actions.rowActions.filter(function (action) {
                return !buildCondition(action.hideRowJson, row);
            });
        };

        self.clearSelection = function () {
            self.selectedRow.isSelected = false;
            self.selectedRow = null;
        };

        self.startAction = function (button, gridRow, dialogModel) {
            var profileActions = new ProfileActions();
            var row = { gridRow: gridRow || self.selectedRow };

            if (button.buttonType === 'SHOW_ROOM_HISTORY') {
                showRoomHistory = !showRoomHistory;
                ListGridStatus.grid.gridOptions.data = ListGridHelper.getFilteredRoomHistoryRecords(ListGridStatus.originalGridData, showRoomHistory);
            } else if (self.isMultiselect() && !button.isGlobalAction) {
                var selectedRows = ListGridStatus.gridApi.selection.getSelectedRows();
                row.model = [];
                selectedRows.forEach(r => row.model.push(composeRowData({ entity: r })));
                ConfirmationService.YesNoConfirmation('Are you sure you want to perform this action on the select rows?', null, { no: 'Never mind', yes: 'Yes' })
                    .Yes(function () {
                        profileActions.runAction(button, row, dialogModel, callback);
                    })
                    .Ask();
            } else {
                row.model = button.showOnSelect || !ListGridStatus.grid.infoTabModel && row.gridRow ? composeRowData(row.gridRow) : ListGridStatus.grid.infoTabModel;
                profileActions.runAction(button, row, dialogModel, callback);
            }

        };

        self.showActionIcon = function (row, editType, mode) {

            if (type === ListGridConstants.Types.Dashboard) {
                return !row.groupHeader && self.getRowActions(row).length > 0 && !self.isMultiselect();
            }

            return !row.groupHeader && (mode === ListGridConstants.Mode.NONE || editType === ListGridConstants.EditType.DIALOG);

        };

        self.disable = function (button) {
            return button.showOnSelect && (!ListGridStatus.gridApi || ListGridStatus.gridApi.selection.getSelectedRows().length === 0);
        };

        self.isDraggable = function () {
            return ListGridStatus.gridSettings.dragging.isDraggable();
        };

        self.showAddGroupBtn = function (row, mode) {
            return ListGridStatus.grid.canInsert &&
                   mode === ListGridConstants.Mode.NONE &&
                   ListGridStatus.gridSettings.grouping.showAddGroupBtn(row);
        };

        self.onRowHover = function (row) {
            $('.row-uid-' + row.uid).addClass('ui-grid-row-hover');
        };

        self.onRowOut = function (row) {
            $('.row-uid-' + row.uid).removeClass('ui-grid-row-hover');
        };

        self.getAddRowMargin = function (row) {
            return ListGridStatus.gridSettings.grouping.getAddRowMargin(row);
        };

        self.showInlineEditIcon = function (editType) {
            return ListGridStatus.grid.canEdit && editType === ListGridConstants.EditType.INLINE;
        };

        self.showDialogEditIcon = function (editType) {
            return ListGridStatus.grid.canEdit && editType === ListGridConstants.EditType.DIALOG;
        };

        self.showDeleteIcon = function () {
            return ListGridStatus.grid.canDelete;
        };

        self.isMultiselect = function () {
            return ListGridStatus.gridApi && ListGridStatus.gridApi.grid.options.multiSelect;
        };


        self.selectRow = function (row) {
            if (!row || row.groupHeader) {
                return;
            }

            if (self.selectedRow) {
                self.selectedRow.isSelected = false;
            }

            self.selectedRow = row;
            self.selectedRow.isSelected = true;
        };

        //privarte methods

        function buildCondition(conditionsJSON, row) {

            if (!conditionsJSON) {
                return;
            }

            var result = '';
            var conditions = JSON.parse(conditionsJSON);

            conditions.forEach(function (condition) {

                var column = ListGridHelper.getColumnByFieldName(condition.field);

                if (column) {

                    if (condition.andor && condition.andor === 'and') {
                        result += '&&';
                    }

                    if (condition.andor && condition.andor === 'or') {
                        result += '||';
                    }

                    if (condition.paren && condition.paren === '(') {
                        result += '(';
                    }

                    var columnName = column.name;

                    condition.operator = condition.operator || '=';

                    switch (condition.operator) {
                        case '=': case 'equals':
                            result += '"{0}"=="{1}"'.format(row.entity[columnName], condition.value);
                            break;

                        case 'notEqualTo': case 'not equal': case 'not equal to': case '!=':
                            result += '"{0}"!="{1}"'.format(row.entity[columnName], condition.value);
                            break;

                        case 'lessThan': case 'less than': case '<':
                            result += '"{0}"<"{1}"'.format(row.entity[columnName], condition.value);
                            break;

                        case 'greaterThan': case 'greater than': case '>':
                            result += '"{0}">"{1}"'.format(row.entity[columnName], condition.value);
                            break;

                        case 'lessThanOrEquals': case 'less than or equal to': case 'lessThanOrEqualTo': case '<=':
                            result += '"{0}"<="{1}"'.format(row.entity[columnName], condition.value);
                            break;

                        case 'greaterThanOrEquals': case 'greater than or equal to': case 'greaterThanOrEquals': case '>=':
                            result += '"{0}">="{1}"'.format(row.entity[columnName], condition.value);
                            break;

                        case 'startsWith': case 'starts with': case 'StartWith':
                            result += '"{0}".startsWith("{1}")'.format(row.entity[columnName], condition.value);
                            break;

                        case 'contains':
                            result += '"{0}".indexOf("{1}")!=-1'.format(row.entity[columnName], condition.value);
                            break;

                        case 'in': case 'inList':
                            result += '"{0}".indexOf("{1}")!=-1'.format(condition.value, row.entity[columnName]);
                            break;

                        case 'not in': case 'notIn': case 'notInList':
                            result += '"{0}".indexOf("{1}")==-1'.format(condition.value, row.entity[columnName]);
                            break;

                        case 'is null': case 'isNull':
                            result += '!{0}'.format(row.entity[columnName]);
                            break;

                        case 'is not null': case 'isNotNull':
                            result += '{0}'.format(row.entity[columnName]);
                            break;

                        case 'between':
                            if (column.type === 'DATE') {
                                result += 'new Date({0}).getTime()>new Date({1}).getTime()&&new Date({2}).getTime()<new Date({3}).getTime()'.format(row.entity[columnName], condition.value, row.entity[columnName], condition.highValue);
                            } else {
                                result += '{0}>{1}&&{2}<{3}'.format(row.entity[columnName], condition.value, row.entity[columnName], condition.highValue);
                            }
                            break;
                    }

                    if (condition.paren && condition.paren === ')') {
                        result += ')';
                    }
                }
            });

            try {
                result = eval(result); //jshint ignore:line
            } catch (e) {
                if (e instanceof SyntaxError) {
                    console.error(e.message);
                    result = false;
                }
            }

            return result;
        }

        function composeRowData(row) {
            var result = {};

            ListGridStatus.columns.forEach(function (column) {
                result[column.fieldName] = row.entity[column.name];
            });

            return result;
        }
        
    }

    return (ListGridRowActions);
}]);